<div class="contact-roles-container">
  <div class="header">
    <h2>Role Catalog</h2>
  </div>

  <div class="info-banner" style="padding: 1rem; background: #f5f5f5; border-radius: 4px; margin: 1rem 0;">
    <p>
      <strong>Role management moved to BCSaaS v1.3.x.</strong>
    </p>
    <p>
      Roles are now managed as <code>BC: Organization Roles</code> (seeded by the BCSaaS migration:
      Owner / Admin / Member / Read Only). Editing this catalog directly is no longer supported from
      the admin UI &mdash; the role definitions are migration-controlled to ensure consistent Level
      semantics across the platform.
    </p>
    <p>
      To assign a role to a user, use the <strong>Members</strong> admin panel.
    </p>
  </div>
</div>
